import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../core/enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ProductSheetService {

  private uri = this.envSvc.getEnvVar('api_products')

  constructor(private http: HttpClient,
              private envSvc: EnvironmentService) { }

  getProduct(sku: string) {
    return this.http.get<any>(`${this.uri}/products/${sku}`);
  }

}
